import { API_STATUS } from 'constants/enums';

interface KeyMirror {
  LOAD: string;
  SUCCESS: string;
  FAIL: string;
}

export interface AuthActionTypes {
  'LOGIN_VIA_QR/CREATE_TOKEN'?: KeyMirror;
  'LOGIN_VIA_QR/GET_TOKEN_DETAILS'?: KeyMirror;

  'SSO_LOGIN/GET_CLIENT_INFO'?: KeyMirror;
  'SSO_LOGIN/CONFIRM_SSO_LOGIN'?: KeyMirror;
  'SSO_LOGIN/AUTHORIZE_FRESKDESK'?: KeyMirror;
}

type ViaQrStatus = 'IS_REFRESHING' | 'LOADED' | 'SHOULD_REFRESH';

export enum QrAuthStatus {
  NEW = 'NEW',
  APPROVED = 'APPROVED',
}

export enum LoginViaQrTokenStatus {
  IS_REFRESHING = 'IS_REFRESHING',
  LOADED = 'LOADED',
  SHOULD_REFRESH = 'SHOULD_REFRESH',
}

export interface ViaQr {
  status: ViaQrStatus;
  value: string | null;
  expiryAt: number | null;
}

export interface Login {
  viaQr: ViaQr;
}

export interface SSOLoginClient {
  name: string;
  logo: string;
}

export interface SSOLogin {
  redirectURI: string;
  freskDeskAPIStatus: API_STATUS;
  clientInfo: SSOLoginClient;
  thirdPartyFetchAPIStatus: API_STATUS;
  thirdPartyConfirmAPIStatus: API_STATUS;
  thirdPartyAuthData: {
    redirect: boolean;
    uri: string;
    auth_code: string;
    state: string;
  };
}

export interface Auth {
  login: Login;
  ssoLogin: SSOLogin;
}

export interface TwoFactorAuthQrData {
  google_secret: string;
  qr_url: string;
}
